import { FC } from 'react';
import { TextField } from '@mui/material';
import { IHsCodeItem } from 'redux/reducers/hscodes/types';
import { CustomFieldProps } from './types';

export const CustomField: FC<CustomFieldProps> = ({
	label,
	hsCodeInput,
	onInputChange,
	onValueChange,
}) => {
	return (
		<TextField
			size="small"
			label={`${label} (Custom)`}
			placeholder="Enter custom HS code"
			variant="outlined"
			value={hsCodeInput}
			onChange={(event) => {
				onInputChange(event.target.value);
				const customHsCode: IHsCodeItem = {
					id: 0,
					code: event.target.value,
					description: 'Custom HS Code',
					isLeaf: true,
				};
				onValueChange(event.target.value ? customHsCode : null);
			}}
			helperText="Enter your own custom HS code"
		/>
	);
};
